export function getLink() {
    const server = `${this.$config.project}-${this.$config.key}`;
    let name; 
    
    switch(server){
        case "hilfy-prod":
            name = "hilfy";
            break;
        case "hilfy-stage":
            name = "hilfy-stage";
            break;
        case "hilfy-dev":
            name = "hilfy-dev";
            break;

        case "profy-prod":
            name = "profy";
            break;
        case "profy-stage":
            name = "profy-stage";
            break;
        case "profy-dev":
            name = "profy-dev";
            break;
        default:  
            break;
    }

    return `${name}://auth?loggedIn=true`;
}
